module.exports = __webpack_public_path__ + "static/img/water.4b615095.svg";